/** CSS class for masking text in Mixpanel session replay. */
export const RECORDING_MASK_SELECTOR = '.record-mask'

/** CSS class for blocking elements entirely from session replay. */
export const RECORDING_BLOCK_SELECTOR = '.record-block'

/**
 * Start Mixpanel session replay on authenticated CA routes.
 * The account app is entirely customer-account surface — skip auth pages only.
 */
export const SESSION_RECORDING_EXCLUDED_PATHS = ['/login', '/forgot-password', '/confirm-forgot-password','/email-sent'] as const
